import {useMemo} from "react";
import {useSelector} from "react-redux";
import {metaMediaType} from "../../../utilities/MetaUtils";

export default function useFacebookMedia(mediaId, type) {
    const fbState = useSelector(state => {
        if (type === metaMediaType.PHOTO) return state.meta.fbPhotos;
        if (type === metaMediaType.VIDEO) return state.meta.fbVideos;
        return {};
    });

    const mediaArray = fbState?.data?.media;
    const loading = fbState?.loading;
    const error = fbState?.error;

    const media = useMemo(() => {
        if (!loading && Array.isArray(mediaArray)) {
            return mediaArray.find(item => item.mediaId === mediaId);
        }
    }, [loading, mediaArray, mediaId]) || null;

    return { loading, media, error };
}
